import Vue from 'vue';

import { initialize } from '../../../util/sentry';
initialize(Vue);

import relatedWishlistsComponent from '../../../components/shop/details/relatedWishlists.vue';

new Vue({
  el: '#vue-related-wishlist-area',
  components: {
    'vue-related-wishlists': relatedWishlistsComponent
  }
});
